module.exports = __webpack_public_path__ + "media/images/black_background-4ecd522d1a6d281f60744fa4f60b9577.png";